"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Utils = __importStar(require("../utils"));
var loots_json_1 = __importDefault(require("./loots.json"));
exports.generate = function (props) {
    if (props === void 0) { props = {}; }
    var source = props.source, seed = props.seed, quantity = props.quantity;
    seed = seed || Utils.FantasyContentGeneratorSeed || Utils.generateUUID();
    quantity = quantity || 1;
    return Utils.withSeed(seed, function () {
        source = source || Utils.pick(loots_json_1.default.loot_source);
        var lootItems = Utils.pickMany(loots_json_1.default.loot_per_loot_source[source], quantity).map(function (l) { return Utils.parseTemplate(l); });
        return {
            seed: seed,
            source: source,
            lootItems: lootItems,
            quantity: quantity,
            formattedData: {
                lootItems: lootItems,
                quantity: quantity,
                label: source + " #" + seed.substring(0, 8)
            }
        };
    });
};
var functions = {
    generate: exports.generate
};
exports.default = functions;
